import type { Module } from "vuex";

import { UserActions, UserRoles } from "@/enums/user";

import type { RootState } from "@/store/types";

const storeNamespace = "roles";

export const RolesMutation = {
    SetRoles: "setRoles"
};
export const RolesAction = {
    SetRoles: `${storeNamespace}/${RolesMutation.SetRoles}`
};

export const RolesGetter = {
    getRolesThatHaveAction: `${storeNamespace}/getRolesThatHaveAction`,
    getRolesThatDoNotHaveAction: `${storeNamespace}/getRolesThatDoNotHaveAction`,
    getCollaboratorRole: `${storeNamespace}/getCollaboratorRole`
};

export type Action = (typeof UserActions)[keyof typeof UserActions];

export type Role = {
    _id: string;
    name: (typeof UserRoles)[keyof typeof UserRoles];
    actions: Action[];
    __typename: "UserRole";
};

export type State = {
    roles: Role[];
};

const getDefaultState = (): State => ({
    roles: []
});

const rolesModule: Module<State, RootState> = {
    namespaced: true,
    state: getDefaultState(),

    getters: {
        getRolesThatHaveAction: state => (action: Action) => state.roles.filter(role => role.actions.includes(action)),

        getRolesThatDoNotHaveAction: state => (action: Action) =>
            state.roles.filter(role => !role.actions.includes(action)),

        getCollaboratorRole: state => state.roles.find(role => role.name === UserRoles.Collaborator)
    },

    mutations: {
        setRoles(state, roles: State["roles"]) {
            state.roles = roles;
        }
    },

    actions: {
        setRoles({ commit }, roles: State["roles"]) {
            commit(RolesMutation.SetRoles, roles);
        }
    }
};

export default rolesModule;
